import { Component, Input } from '@angular/core';
import { EverythingSearchResult } from '../../model/everything-search-result';
import { MediaType } from '../../model/search-constants';
import { TruthyPipe } from '../../pipe/truthy.pipe';
import { SearchResultLinkDirective } from '../../search-result-link.directive';
import { CrumbComponent } from '../../utils/crumb/crumb.component';

@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: [ './search-result.component.scss' ],
  imports: [ SearchResultLinkDirective, CrumbComponent, TruthyPipe ]
})
export class SearchResultComponent {
  @Input() result: EverythingSearchResult;
  @Input() crumbs: string[] = [];
  MediaType = MediaType;
}
